import React, { Component } from 'react';
import { styleMapping } from "../utils/tools";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { truncate, reverseArray, getEquivalent } from "../utils/tools";
// import * as actions from '../../store/pseudo/general';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as server from "../../resources/constants/api";
import { buildSpacesUrlFromKey } from "../../utils/activityStorage";
import notify from "../../services/notify";

class Viewer extends Component {
  
  constructor(props) {
    super(props);
    this.state = { id: props.id, bFullscreen: false, carouselIndex: 0 };
    this.images = null;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleCarouselKeyDown, true);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleCarouselKeyDown, true);
  }

  resolveImageUrl = (imageData) => {
    const raw = (
      typeof imageData === 'string'
        ? imageData
        : (imageData && (imageData.url || imageData.path || imageData.src || imageData.image))
    );
    if (!raw || typeof raw !== 'string') {
      return '';
    }

    const normalized = buildSpacesUrlFromKey(raw);
    if (normalized) {
      return normalized;
    }

    if (raw.substr(0, 4) === 'http' || raw.substr(0, 5) === 'data:') {
      return raw;
    }

    return server.URL_SERVER_DJANGO_S3 + raw;
  }


  // ############################ HANDLE NEW IMAGE ###################################
  // ############################ HANDLE NEW IMAGE ###################################
  handleImage(e){
    const input = e.target;
    if (input.files && input.files.length) {
      // console.log('HANDLE IMAGE SIZE => ', input.files[0].size);
      if (input.files && input.files[0] && input.files[0].size < 4000000) {
        const reader = new FileReader();
        reader.onloadend = (e) => {
          let image = reader.result;
          // console.log('NEW IMAGE => ', image);
          this.props.onAction('new', image);
        };
        reader.readAsDataURL(input.files[0]);
      } else notify.error("Image size needs to be inferior to 3MB", { autoClose: 2200, title: "Upload failed" });

    }
  } 

  // ############################ RENDER ###################################
  // ############################ RENDER ###################################
  render() {
    const { styleList, onAction, type, images, limit } = this.props;
    const isDisplayMode = type === 'display';
    let limit2 = limit;
    if(!limit) {limit2 = 20;}

    if(images){
        const imageKeys = Object.keys(images);
        const imageCount = imageKeys.length;
        const activeIndex = Math.min(Math.max(this.state.carouselIndex, 0), Math.max(0, imageCount - 1));
        const activeImage = (imageCount > 0 ? images[imageKeys[activeIndex]] : null);
        const activeImageUrl = (activeImage ? this.resolveImageUrl(activeImage) : '');

        return (
              <div className={styleList.imageContainer.class + " viewer-gallery-shell" + (isDisplayMode ? " is-display" : " is-edit")} style={styleMapping(styleList.imageContainer)}>
                  <div className="viewer-gallery-track">
                    {imageKeys.map((image,index)=>{
                      const imageData = images[image];
                      const url = this.resolveImageUrl(imageData);
                      const isDeleted = (!isDisplayMode && imageData && imageData.action === 'delete');
                      return(
                          <div
                            key={index}
                            className={
                              styleList.imageDiv.class +
                              " viewer-thumb-card" +
                              (index === activeIndex ? " is-active" : "") +
                              (isDeleted ? " is-deleted" : "")
                            }
                            style={styleMapping(styleList.imageDiv)}
                            role="button"
                            tabIndex={0}
                            onClick={()=>{this.carousel(true, index)}}
                            onKeyDown={(event)=>{if(event.key === 'Enter' || event.key === ' '){event.preventDefault(); this.carousel(true, index);}}}
                            aria-label={"Open image " + (index + 1)}
                          >
                              <img alt="" src={url} className={styleList.image.class + " viewer-thumb-image"} style={styleMapping(styleList.image)} />
                              <div className="viewer-thumb-gradient" aria-hidden="true"></div>
                              <div className="viewer-thumb-index">{index + 1}</div>

                              {!isDisplayMode && !isDeleted && (
                                <button
                                  type="button"
                                  onClick={(event)=>{event.stopPropagation(); onAction('delete', index);}}
                                  className="viewer-thumb-action is-delete"
                                  aria-label={"Remove image " + (index + 1)}
                                >
                                  <i className={"fa fa-remove"}></i>
                                </button>
                              )}

                              {!isDisplayMode && isDeleted && (
                                <React.Fragment>
                                  <div className="viewer-thumb-deleted-overlay">Marked for removal</div>
                                  <button
                                    type="button"
                                    onClick={(event)=>{event.stopPropagation(); onAction('reset', index);}}
                                    className="viewer-thumb-action is-reset"
                                    aria-label={"Restore image " + (index + 1)}
                                  >
                                    <i className={"fa fa-history"}></i>
                                  </button>
                                </React.Fragment>
                              )}
                          </div>
                    );
                    })}
                    {!isDisplayMode && imageCount < limit2 && (
                      <label className={styleList.imageDiv.class + " viewer-thumb-card viewer-thumb-add"} style={styleMapping(styleList.imageDiv)}>
                        <div className="viewer-thumb-add-inner">
                          <FontAwesomeIcon icon={"image"} className="viewer-thumb-add-icon"/>
                          <span className="viewer-thumb-add-label">Add photo</span>
                        </div>
                        <input onChange={(e)=> this.handleImage(e)} className="viewer-thumb-add-input" type="file" />
                      </label>
                    )}
                  </div>

                  {/* FULLSCREEN CAROUSEL */}
                  {this.state.bFullscreen && 
                    <div className={"viewer-carousel-overlay " + styleList.carouselContainer.class} style={styleMapping(styleList.carouselContainer)} onClick={(e) => { e.stopPropagation(); this.carousel(false); }}>
                      <div className="viewer-carousel-topbar">
                        <div className="viewer-carousel-counter">{(activeIndex + 1)} / {imageCount}</div>
                        <button type="button" className="viewer-carousel-close" onClick={(e)=>{e.stopPropagation();this.carousel(false);}} aria-label="Close gallery">
                          <i className="fa fa-times-circle"/>
                        </button>
                      </div>

                      <div className={"viewer-carousel-stage " + styleList.carousel.class} style={styleMapping(styleList.carousel)}>
                        {imageCount > 1 && <button type="button" className="viewer-carousel-nav prev" onClick={(e) => {if (e.target === e.currentTarget) { this.carousel(false); return; } e.stopPropagation(); this.prevSlide(imageCount);}} aria-label="Previous image"><i className="fa fa-angle-left"/></button>}
                        {activeImageUrl && <img alt="" className="viewer-carousel-image CarouselFullscreen" src={activeImageUrl} onClick={(e)=>{e.stopPropagation(); this.carousel(false);}} />}
                        {imageCount > 1 && <button type="button" className="viewer-carousel-nav next" onClick={(e) => {if (e.target === e.currentTarget) { this.carousel(false); return; } e.stopPropagation(); this.nextSlide(imageCount);}} aria-label="Next image"><i className="fa fa-angle-right"/></button>}
                      </div>

                      {imageCount > 1 && <div className="viewer-carousel-dots">
                        {imageKeys.map((image,index) => {
                          return (
                            <button
                              key={index}
                              type="button"
                              className={"viewer-carousel-dot" + (index === activeIndex ? " active" : "")}
                              onClick={(e) => {e.stopPropagation(); this.setState({carouselIndex: index});}}
                              aria-label={"Show image " + (index + 1)}
                            />
                          );
                        })}
                      </div>}
                    </div>
                  }


              </div>
          );
        // return null;
    } else return null;
  }


  // ############################ DSIPLAY FULLSCREEN CAROUSEL ###################################
  // ############################ DSIPLAY FULLSCREEN CAROUSEL ###################################
  carousel = (bDisplay, index = 0) => {
    this.setState({bFullscreen: bDisplay, carouselIndex: Math.max(0, index)});
  }

  handleCarouselKeyDown = (e) => {
    if (!this.state.bFullscreen) {
      return;
    }

    const imageCount = Object.keys(this.props.images || {}).length;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      this.carousel(false);
      return;
    }

    if (e.key === 'ArrowRight' && imageCount > 1) {
      e.preventDefault();
      this.nextSlide(imageCount);
      return;
    }

    if (e.key === 'ArrowLeft' && imageCount > 1) {
      e.preventDefault();
      this.prevSlide(imageCount);
    }
  }

  nextSlide = (count) => {
    if (!count || count < 2) {
      return;
    }

    this.setState((prevState) => ({carouselIndex: (prevState.carouselIndex + 1) % count}));
  }

  prevSlide = (count) => {
    if (!count || count < 2) {
      return;
    }

    this.setState((prevState) => ({carouselIndex: (prevState.carouselIndex - 1 + count) % count}));
  }

}

const mapStateToProps = (state) => { return {isAuthenticated: state.status.token !== null && state.status.token !== '' ? true : false, status:state.status, user:state.user, settings:state.settings, architecture:state.architecture};}
export default withRouter(connect(mapStateToProps, null)(Viewer));


